export default __webpack_public_path__ + "static/media/mental-2019.df3db584.jpg";